import angular from 'angular';
import template from './call-frames-media-actions.html';
import * as localMedia from '../../../../modules/local-media';
class CallFramesMediaActionsController {
    constructor($ngRedux) {
        this.$ngRedux = $ngRedux;
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis)(this);
    }
    toggleVideo($event, isEnabled) {
        this.$ngRedux.dispatch(localMedia.actions.toggleVideo(isEnabled));
        $event.stopPropagation();
    }
    toggleAudio($event, isEnabled) {
        this.$ngRedux.dispatch(localMedia.actions.toggleAudio(isEnabled));
        $event.stopPropagation();
    }
    mapStateToThis(state) {
        return {
            hasVideo: localMedia.selectors.hasVideo(state),
            hasAudio: localMedia.selectors.hasAudio(state),
        };
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const callFramesMediaActionsComponent = {
    template,
    bindings: {
        turnOffAudioTabindex: '<?',
    },
    controller: CallFramesMediaActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.callFramesMediaActions', [])
    .component('callFramesMediaActions', callFramesMediaActionsComponent).name;
